import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CertSpec, api } from "../lib/api";

export default function Certs() {
  const [certs, setCerts] = useState<CertSpec[]>([]);

  useEffect(() => {
    api.listCerts().then(setCerts);
  }, []);

  return (
    <div>
      <h1 className="font-display text-3xl mb-6">Certifications</h1>
      <div className="space-y-4">
        {certs.map((cert) => (
          <div key={cert.id} className="card">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div className="min-w-0">
                <div className="text-xs font-mono text-scribe-600 uppercase tracking-wider mb-1">
                  {cert.vendor} · {cert.code}
                </div>
                <h2 className="font-display text-xl mb-2">{cert.name}</h2>
                <p className="text-sm text-ink-700 leading-relaxed">{cert.description}</p>
                <div className="text-xs text-scribe-600 mt-3">
                  {cert.total_questions} questions · {cert.duration_minutes} min
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-col sm:w-44 sm:shrink-0">
                <Link to={`/practice/${cert.id}`} className="btn-secondary w-full">
                  Pratique
                </Link>
                <Link to={`/mock-exam/${cert.id}`} className="btn-primary w-full">
                  Examen blanc
                </Link>
              </div>
            </div>

            <details className="mt-4">
              <summary className="cursor-pointer text-sm text-scribe-600 hover:text-ink-800">
                Domaines ({cert.domains.length})
              </summary>
              <ul className="mt-2 space-y-1 text-sm">
                {cert.domains.map((d) => (
                  <li key={d.id} className="flex justify-between">
                    <span>{d.name}</span>
                    <span className="font-mono text-scribe-600">
                      {(d.weight * 100).toFixed(0)}%
                    </span>
                  </li>
                ))}
              </ul>
            </details>
          </div>
        ))}
      </div>
    </div>
  );
}
